module.exports = __webpack_public_path__ + "static/media/vibino-feature-image Grid-pic2.c1393242.jpg";